<template>
  <div class='navheader'>
    <img class="leftBg" src="../../assets/header/header-left.svg"/>
    <img class="rightBg" src="../../assets/header/header-right.svg"/>
    <div class="leftBtns">
      <HexagonButon :text="t('AICompare.back')" icon="back" v-if="route.path == '/compare/setting'" @click="router.back()"></HexagonButon>
      <template v-if="route.path == '/compare/analysis'" > 
        <span class="dateLabel">{{$t('AICompare.date')}}</span>
        <div class="datePicker"> 
          <t-date-range-picker size="medium" @change="timeChange" v-model="dateArr"/>
        </div>
      </template>

    </div>
    <div class="center">{{$t('AICompare.compareTitle')}}</div>
    <div class="rightBtns">
      <template v-if="route.path == '/compare/analysis'">
        <HexagonButon :text="t('AICompare.selectCompare')" icon="select" @click="openSelect"></HexagonButon>
        <HexagonButon :text="t('AICompare.export')" icon="download" @click="exportImg"></HexagonButon>
      </template>
      <HexagonButon v-if="route.path == '/compare/analysis' || route.path == '/compare/select-teacher' " :text="t('AICompare.modelSettting')" icon="setting" @click="gotoSetting"></HexagonButon>
    </div>
  </div>
</template>

<script setup>
import { onMounted,getCurrentInstance,ref, onUnmounted } from 'vue';
import { LoadingPlugin } from 'tdesign-vue-next';
import html2canvas from 'html2canvas';
import { useRouter,useRoute } from 'vue-router';
import HexagonButon from '../../components/wxButton/Hexagon.vue'
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { $eventBus } = getCurrentInstance().appContext.config.globalProperties;
const router = useRouter()
const route = useRoute()
const dateArr = ref([])
onMounted(() => {
  document.documentElement.setAttribute("theme-mode", "dark");
  $eventBus.on("timeChange", (e) => {
    console.log('timeChange-on-navheader:',e)
    dateArr.value = e
  });
  if(localStorage.getItem('compare-params') == null){
    return
  }
  const params = JSON.parse(localStorage.getItem('compare-params'))
  dateArr.value =[params.startDate, params.endDate]
})
onUnmounted(() => {
  document.documentElement.removeAttribute("theme-mode");
})
const timeChange = (e,e2) => {
  $eventBus.emit('timeChange',e)
}
const gotoSetting = () => {
  router.push('/compare/setting')
}
const openSelect = () => {
  $eventBus.emit('openSelect',true)
}
// 导出图片
const exportImg = () => {
  // isShowExportBg.value = true;
  let targetDom = document.getElementsByClassName('analysis')[0]
  targetDom.scrollTo(0, 0);
  let userCount = parseInt(targetDom.dataset.count)
  targetDom.style.width = userCount > 4 ? 25 * userCount + 'vw' : '100vw';
  LoadingPlugin(true);
  setTimeout(() => {
    html2canvas(targetDom,{
      useCORS: true,
      height: targetDom.scrollHeight,
      windowHeight: targetDom.scrollHeight+60,
    }).then(function(canvas) {
      // 下载图片
      var dataImg = new Image()
      dataImg.src = canvas.toDataURL('image/png')
      let domIng = document.body.appendChild(dataImg)
      var alink = document.createElement("a");
      alink.href = dataImg.src;
      alink.download = t('AICompare.export');
      alink.click();
      // isShowExportBg.value = false;
      domIng.remove()
      targetDom.style.width = '100vw';
      LoadingPlugin(false);
    });
  }, 500);
}
</script>

<style lang="less" scoped>
.navheader{
  height: 60px;
  width: 100%;
  position: relative;
  background: #1A1A1A;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .leftBg{
    position: absolute;
    left: 0;
    top: 0;
    height: 60px;
    z-index: 1;
  }
  .rightBg{
    position: absolute;
    right: 0;
    top: 0;
    height: 60px;
    z-index: 1;
  }
  .center{
    background: url(../../assets/header/header-center.svg);
    height: 60px;
    width: 482px;
    color: #FFF;
    font-size: 24px;
    font-weight: 600;
    line-height: 60px;
    text-align: center;
  }
  .leftBtns,.rightBtns{
    z-index: 2;
  }
  .leftBtns{
    margin-left: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    .dateLabel{
      color: #FFF;
      font-size: 16px;
      font-weight: 600;
    }
    .datePicker{
      width: 270px;
    }
  }
  .rightBtns{
    margin-right: 20px;
    display: flex;
    gap: 10px;
  }
}
</style>